import { MemoFirstArg, memo } from "./function.ts";

/**
 * Parses a string value and returns a boolean value.
 *
 * @param value - The string value to parse.
 * @returns A boolean value representing the parsed value.
 */
export const parseBoolean = memo(MemoFirstArg, (value: string | null | undefined): boolean => {
  value ??= "";
  return ["true", "1"].includes(value.trim().toLowerCase());
});
